// Örnek servis codiagno login
import axios from "../javascript/custom-axios";

const RESOURCE_NAME = "v1/emergency";

export default {

  /**
   * Get Events
   * @param {{ Page: number, PageSize: number, EventStatus: number, EventType: number }} params
   * @returns
   */
  getEvents({ Page = 1, PageSize = 15, ...params }) {
    return axios.get(`${RESOURCE_NAME}/getEvent`, {
      params:{
        Page,
        PageSize,
        ...params
      }
    });
  },

  /**
   * Get Count Report By Event Id
   * @param {{ EventId: number, SafetyStatus: number }} params
   * @returns
   */
  getCountReport(params) {
    return axios.get(`${RESOURCE_NAME}/getCountReport`, {
      params
    });
  },

  /**
   * Download Report File For Event
   * @param {{ EventId: number, SafetyStatus: number }} params
   * @returns
   */
  downloadEventReport(params) {
    return axios.get(`${RESOURCE_NAME}/downloadEventReport`, {
      params,
      responseType: 'blob',
      withCredentials: true,
    });
  },
  
  /**
   * Create An Event
   * @param {{ CreateBy: string, Title: string, EventType: 0, Description: string }} body
   * @returns {Promise}
   */
  createEvent(body) {
    return axios.post(`${RESOURCE_NAME}/event/create`, body);
  },

  /**
   * Update An Event
   * @param {{ EventId: number, CreateBy: string, Title: string, EventType: 0, Description: string }} body
   * @returns {Promise}
   */
  updateEvent(body) {
    return axios.put(`${RESOURCE_NAME}/event/update`, body);
  },

  /**
   * Get Event By Id
   * @param {{ EventId: number, SafetyStatus: number }} params
   * @returns {Promise}
   */
  getEventById(params) {
    return axios.get(`${RESOURCE_NAME}/getUserByStatus`, { params });
  },

  /**
   * Get User By Event Id
   * @param {{ EventId: number }} params
   * @returns {Promise}
   */
  getUser(params) {
    return axios.get(`${RESOURCE_NAME}/getUser`, { params });
  },

  /**
   * Get Event By Id
   * @param {number} id
   * @returns {Promise}
   */
  getEventDataById(id) {
    return axios.get(`${RESOURCE_NAME}/getEventById/${id}`);
  },

  /**
   * Has Emergency
   * @returns {Promise}
   */
  hasEmergency() {
    return axios.get(`${RESOURCE_NAME}/hasEmergency`);
  },

  /**
   * Delete Event
   * @param {number} id
   * @returns {Promise}
   */
  deleteEvent(id) {
    return axios.delete(`${RESOURCE_NAME}/event/delete/${id}`);
  },

  /**
   * Update Password
   * @param {{ Pasword: string }} body
   * @returns {Promise}
   */
  changePassword(body) {
    return axios.post(`${RESOURCE_NAME}/change/password`, body);
  },
};
